module.exports = __webpack_public_path__ + "static/img/三层(1).0144ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/三层(1).png
// module id = Oy3m
// module chunks = 0